/**
 * Pending post-login redirect — the ONE place a "resume here after you sign in"
 * intent is persisted, so it survives flows that drop the `?redirect` query
 * param (notably sign-UP: register → check-email → email confirmation → login).
 *
 * The `(app)` route guard is the single owner:
 *   • On bounce (an unauthenticated user hit a protected route) it stashes the
 *     full route here AND passes it as `?redirect` to login.
 *   • Once the user is authenticated (however they got there — direct sign-in,
 *     or the multi-step confirmation hop), the guard consumes this and navigates.
 *
 * Stored as a plain internal route string (e.g. "/(app)/join/1234"). Same
 * origin/device only (localStorage on web, SecureStore on native).
 */

import { setItem, getItem, removeItem } from './storage'

const KEY = 'pendingRedirect'

export async function setPendingRedirect(path: string): Promise<void> {
  const trimmed = path.trim()
  if (!trimmed) return
  await setItem(KEY, trimmed)
}

export async function getPendingRedirect(): Promise<string | null> {
  return getItem(KEY)
}

export async function clearPendingRedirect(): Promise<void> {
  await removeItem(KEY)
}
